export const PermissionName = {
	ManageSettings: 'Zarządzanie ustawieniami',
	ManageUsers: 'Zarządzanie użytkownikami',
	ManageMenus: 'Zarządzanie menu',
	CreateArticles: 'Tworzenie artykułów',
	ConfirmArticles: 'Zatwierdzanie artykułów',
	PublishArticles: 'Publikacja artykułów',
	ArchiveArticles: 'Archiwizacja artykułów'
};
